import useCollectedUserData from './useCollectedUserData';

const useSessionTakenActionCount = () => {
  const { sessionTakenActionCount } = useCollectedUserData();
  return sessionTakenActionCount;
};

export default useSessionTakenActionCount;
